<template>
	<div class="incenters">
		<div style>
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')"></Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="复制" fontSize="14px" @btnclick="addcopy"
				:src="require('@/assets/icon/icon-fpcpx.png')"></Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px"
				:useAutoOptional="false" :optional="handleList.length !== 1" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')"></Commonbtn>
			<Commonbtn v-if="qx.del" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<!--   -->
			<Commonbtn v-if="qx.del" backgroundColor="#FFF" title="驳回" fontSize="14px" @btnclick="Rejectapproval"
				:src="require('@/assets/channel/Rejectapproval.png')"></Commonbtn>

			<Commonbtn backgroundColor="#FFF" v-if="qx.enabled" title="启用" fontSize="14px" @btnclick="Active"
				:src="require('@/assets/icon/qy.png')"></Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.enabled" title="停用" fontSize="14px" @btnclick="DeActive"
				:src="require('@/assets/icon/icon-stop.png')"></Commonbtn>
			<CommonbtnUpLoad backgroundColor="#FFF" title="导入" fontSize="14px" @getFile="InvoiceImport"
				:src="require('@/assets/icon/icon-drjys.png')"></CommonbtnUpLoad>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="CRExport"
				:src="require('@/assets/icon/daoc.png')"></Commonbtn>
			<CommonbtnUpLoad backgroundColor="#FFF" types="multiple" title="上传照片" fontSize="14px"
				@getFiles="UploadPhotos" :src="require('@/assets/icon/daoc.png')"></CommonbtnUpLoad>
			<a class="Dowload" style @click="DsphfDowload">下载经销商/服务商/医院备案导入模板</a>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable ref="ProviderRef" @cz="cz" @handleSelectionChange="handleSelectionChange"
				@onRowClick="onRowClick" colnum="522" :tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<DialogFrom width="1000px" title="新增经销商/服务商/医院备案" :dialogVisible="dialogVisibles" @cancel="cancel"
			@dialogOK="dialogOK">
			<div class="from" style="position: relative;overflow-y: scroll;height: 500px;">
				<template v-for="(item , index) of fromdataadd">
					<Commondropdownlist :key="index" ref="DsphFAddref" :event="item.event" :disabledHB="item.disabled"
						:selcoms="item.selcoms" :widths="item.widths" :radio="item.radio" :loading="loading" @JXSChage="JXSChage"
						@remoteMethodtows="remoteMethodtows" @remoteMethodtowPer="remoteMethodtowPer"
						@remoteMethodtowHB="remoteMethodtowHB" @remoteHosType="remoteHosType" :options="item.options"
						:btx="item.btx" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
						:color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2"
						:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
						:inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max"
						:checkboxdata="item.checkboxdata" :disabled="item.disabled"></Commondropdownlist>
				</template>
				<CommonUploadEnclosure @getFiles="getFileDsphImg" types="multiple" style="height: 120px;">
				</CommonUploadEnclosure>
				<div class="SMSProviderFlex">
					<FilesAndPictures class="FilesAndPictures" :DelFlag="true"
						v-for="(item , index) of SMSProviderUploadData" :key="'DSPHF'+index" :fileAddImgData="item"
						:index="index" @See="See" @Del="Del"></FilesAndPictures>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom width="1000px" title="修改经销商/服务商/医院备案" :loading="loading" :dialogVisible="dialogVisiblesedit"
			@cancel="canceledit" @dialogOK="dialogOKedit">
			<div class="from" style="overflow-y: scroll;height: 500px;">
				<template v-for="(item , index) of fromdataedit">
					<Commondropdownlist ref="DsphFEditref" :event="item.event" @JXSUPChage="JXSUPChage"
						:disabledHB="item.disabled" :disabled="item.disabled" :radio="item.radio" :key="index"
						:widths="item.widths" :options="item.options" @remoteMethodtows="remoteMethodtows"
						@remoteMethodtowPer="remoteMethodtowPer" @remoteMethodtowHB="remoteMethodtowHB"
						@remoteHosType="remoteHosType" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
						:radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min"
						:max="item.max"></Commondropdownlist>
				</template>
				<CommonUploadEnclosure @getFiles="getFileDsphImg" types="multiple" style="height: 120px;">
				</CommonUploadEnclosure>
				<div class="uploadImg">
					<div class="SMSProviderFlex">
						<FilesAndPictures class="FilesAndPictures" :DelFlag="true"
							v-for="(item , index) of SMSProviderUploadData" :key="'DSPHF'+index" :index="index"
							:fileAddImgData="item" @See="See" @Del="Del"></FilesAndPictures>
					</div>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom width="1000px" title="驳回原因" :loading="loading" :dialogVisible="dialogVisiblesRejectReason"
			@cancel="cancelRejectReason" @dialogOK="dialogOKRejectReason">
			<div class="from" style="overflow-y: scroll;height: 300px;">
				<el-input type="textarea" placeholder="请输入驳回原因" v-model="RejectReason"></el-input>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除当前选中的信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要启用当前选中的信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivateDe" @cancel="canceldeactivateDe"
			@dialogOK="dialogOKdeactivateDe" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用当前选中的信息吗？</span>
		</Dialog>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum="100" :tableData="tableDatadrjg"
					height="100%"></Commontable>
			</div>
		</DialogFrom>
		<Commonpictureswitching :show="show" @hidefn="hidefn" :picImages="picImages"></Commonpictureswitching>
		<Prviwe :show="shows" @hidefn="hidefns" :imgsrc="imgsrc"></Prviwe>
	</div>
</template>
<script>
	import Commondropdownlist from "../../../../components/common-dropdownlist.vue";
	import Prviwe from "../../../../components/picturepreview.vue";
	import Commontable from "../../../../components/common-table.vue";
	import Commonbtn from "../../../../components/common-btn.vue";
	import Pagination from "../../../../components/pagination.vue";
	import DialogFrom from "../../../../components/dialog-from.vue";
	import fromdata from "../fromData/add";
	import fromdataedit from "../fromData/edit";
	import Dialog from "../../../../components/dialog.vue";
	import Commondown from "../../../../components/common-down.vue";
	import CommonbtnUpLoad from "../../../../components/common-upload.vue";
	import Commonpictureswitching from "../../../../components/common-pictureswitching.vue";
	import arrAll from "../../../../common/area";
	import CommonUploadEnclosure from "../../../../components/common-upload-Enclosure.vue";
	import FilesAndPictures from "@/components/FilesAndPictures.vue";
	import {
		CusRelationProviderAdd,
		CusRelationProviderInfo,
		CusRelationProviderEdit,
		CusRelationProviderGetInvoicePic,
		CusRelationProviderDelete,
		CusRelationProviderActive,
		CusRelationProviderDeActive,
		CusRelationProviderImport,
		CusRelationProviderUploadSalesInvListPic,
		CusRelationProviderDownloadTemplet,
		CusRelationProviderUploadSalesInvListByEdit,
		HospitalGetHospitalType,
		InventoryClassList,
		CustomerList,
		HospitalList,
		HospitalInfo,
		CusRelationProviderReject
	} from "@/api/home";
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			Commondown,
			CommonbtnUpLoad,
			Commonpictureswitching,
			CommonUploadEnclosure,
			Prviwe,
			FilesAndPictures
		},
		props: {
			tableData: {
				type: Array,
				default: []
			},
			total: {
				type: Number,
				default: 0
			}
		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				dialogVisibledeactivateDe: false,
				dialogVisiblesRejectReason: false,
				rowboo: false,
				dialogVisiblesdrjg: false,
				arrCityAll: arrAll, //全部城市
				cityArr: [], //市
				rightboo: false,
				dwonleft: false,
				loading: false,
				show: false,
				shows: false,
				title: "结果",
				RejectReason: "", //删除原因
				ID: "",
				imgsrc: "",
				ptype: "",
				HPid: "",
				HospHPid: "",
				InvClassCode: "",
				InvClassCodeName: "",
				HPidName: "",
				HospHPidName: "",
				TXCusName: "",
				TXCusID: "",
				stateDelIcon: "",
				FileName: [],
				ImageUrl: [],
				fromdataadd: [],
				fromdataedit: [],
				handleList: [],
				tableDatadrjg: [],
				SMSProviderUploadData: [],
				headerData: [{
						prop: "id",
						label: "序号",
						columnwidth: 50
					},
					{
						prop: "OperateName",
						label: "操作",
						columnwidth: 60
					},
					{
						prop: "CusName",
						label: "经销商名称",
						columnwidth: 220
					},
					{
						prop: "InvClassName",
						label: "产品线",
						columnwidth: 60
					},
					{
						prop: "TXCusName",
						label: "下级经销商",
						columnwidth: 230
					},
					{
						prop: "ProviderName",
						label: "指定配送商/采购代理",
						columnwidth: 250
					},
					// {
					//   prop: 'ProviderType',
					//   label: '配送商分类',
					//   columnwidth: 230
					// },
					{
						prop: "HPName",
						label: "医院名称",
						columnwidth: 160
					},
					{
						prop: "Remark",
						label: "备注",
						columnwidth: 160
					},
					{
						prop: "HasHPInvoiceName",
						label: "是否有终端医院发票",
						columnwidth: 160
					},
					{
						prop: "CreatorName",
						label: "创建人",
						columnwidth: 160
					},
					{
						prop: "CreateTime",
						label: "创建开始时间",
						columnwidth: 160
					},
					{
						prop: "UpdaterName",
						label: "修改人",
						columnwidth: 160
					},
					{
						prop: "UpdateTime",
						label: "修改时间",
						columnwidth: 160
					},
					{
						prop: "ActivorName",
						label: "停启用人",
						columnwidth: 160
					},
					{
						prop: "ActivorTime",
						label: "停启用日期",
						columnwidth: 160
					},
					{
						prop: "VouchValiDate",
						label: "备案有效期",
						columnwidth: 160
					}
				],
				picImages: [],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false
				}
			};
		},
		created() {},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata));
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit));
			this.QX();
		},
		methods: {
			//复制
			addcopy() {
				if (this.rowboo == true) {
					this.copyCusRelationProviderInfo();
					this.inventoryClassList();
					return;
				}
				this.$message({
					type: "error",
					message: "请选择要修改的数据！"
				});
			},
			// 详情
			async copyCusRelationProviderInfo() {
				const loading = this.$loading({
					lock: true,
					text: "正在加载详情中...",
					spinner: "el-icon-loading",
					background: "rgba(255,255,255,0.3)"
				});
				let {
					code,
					message,
					data
				} = await CusRelationProviderInfo({
					ID: this.ID
				});
				if (code == 0) {
					this.fromdataadd[0].inputdata = data.InvClass;
					this.fromdataadd[1].inputdata = data.CusName;
					this.fromdataadd[2].inputdata = data.TXCusName;
					this.fromdataadd[3].inputdata = data.ProviderName;
					this.fromdataadd[4].inputdata = data.HPName;
					this.fromdataadd[5].inputdata = data.VouchValiDate;
					this.fromdataadd[6].inputdata = data.Remark;
					this.fromdataadd[7].radio = data.HasHPInvoice + "";
					data.lstImages.map((item, index) => {
						this.SMSProviderUploadData.push(item)
						// this.ImageUrl.push(item.ImageUrl);
						// this.FileName.push(item.ImagePath);
					});
					this.InvClassCodeName = data.CusName;
					this.HPidName = data.ProviderName;
					this.HospHPidName = data.HPName;
					this.InvClassCode = data.CusCode;
					this.TXCusName = data.TXCusName;
					this.TXCusID = data.TXCusID;
					this.HPid = data.ProviderID;
					this.HospHPid = data.Hospital;
					loading.close();
					this.dialogVisibles = true;
				}
				loading.close();
			},
			See(par) {
				if (par.Extension == 'jpg' || par.Extension == 'png' || par.Extension == 'gif') {
					this.shows = true
					this.imgsrc = par.ImageUrl
				} else if (par.Extension == 'pdf') {
					window.open(par.ImageUrl, '_blank')
				} else {
					window.location.href = par.ImageUrl
				}
			},
			Del(fileAddImgData) {
				console.log(fileAddImgData);
				this.SMSProviderUploadData.splice(fileAddImgData.index, 1)
			},
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"));
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 35) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 56) {
								this.qus = items.Nodes;
							}
						});
					}
					// console.log(this.qus, 'this.qus');
				});
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == "add") {
							this.qx.add = true;
						} else if (item.NodeName == "edit") {
							this.qx.update = true;
						} else if (item.NodeName == "delete") {
							this.qx.del = true;
						} else if (item.NodeName == "stopif") {
							this.qx.del = true;
						} else if (item.NodeName == "assignment") {
							this.qx.assignment = true;
						} else if (item.NodeName == "enabled") {
							this.qx.enabled = true;
						} else if (item.NodeName == "skip") {
							this.qx.skip = true;
						} else if (item.NodeName == "reset") {
							this.qx.reset = true;
						} else if (item.NodeName == "setting") {
							this.qx.setting = true;
						}

					});
				}
				//console.log(this.qus, 'this.qus');
			},
			async cusRelationProviderGetInvoicePic(id) {
				let {
					code,
					data
				} = await CusRelationProviderGetInvoicePic({
					ID: id
				});
				if (code == 0) {
					console.log(data.picImages);
					this.picImages = data.picImages;
				}
			},
			cz(ID) {
				this.cusRelationProviderGetInvoicePic(ID);
				this.show = true;
			},
			hidefn() {
				this.show = false;
			},
			hidefns() {
				this.shows = false;
			},

			async remoteCustomer(val) {
				let {
					data,
					code
				} = await CustomerList({
					CusName: val
				});
				if (code == 0) {
					this.InvClassCode = data.data[0].CusCode;
				}
			},
			// 二级经销商下拉
			async remoteMethodtowPer(query) {
				this.loading = true;
				let {
					data,
					code
				} = await CustomerList({
					CusName: query
				});
				if (code == 0) {
					this.fromdataadd[1].options = [];
					this.fromdataedit[1].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CusName
						};
						this.fromdataadd[1].options.push(obj);
						this.fromdataedit[1].options.push(obj);
					});
					this.loading = false;
				}
			},
			async hospitalGetHospitalType() {
				let {
					data,
					code
				} = await HospitalGetHospitalType({});
				if (code == 0) {
					// this.fromdataadd[2].options = []
					// this.fromdataedit[2].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Name,
							value: item.Name
						};
						// this.fromdataadd[2].options.push(obj)
						// this.fromdataedit[2].options.push(obj)
					});
				}
			},
			// 详情
			async cusRelationProviderInfo() {
				const loading = this.$loading({
					lock: true,
					text: "正在加载详情中...",
					spinner: "el-icon-loading",
					background: "rgba(255,255,255,0.3)"
				});
				let {
					code,
					message,
					data
				} = await CusRelationProviderInfo({
					ID: this.ID
				});
				if (code == 0) {
					this.fromdataedit[0].inputdata = data.InvClass;
					this.fromdataedit[1].inputdata = data.CusName;
					// this.fromdataedit[2].inputdata = data.ProviderType
					this.fromdataedit[2].inputdata = data.TXCusName;
					this.fromdataedit[3].inputdata = data.ProviderName;
					this.fromdataedit[4].inputdata = data.HPName;
					this.fromdataedit[5].inputdata = data.VouchValiDate;
					this.fromdataedit[6].inputdata = data.Remark;
					this.fromdataedit[7].radio = data.HasHPInvoice + "";
					data.lstImages.map((item, index) => {
						this.SMSProviderUploadData.push(item)
						// this.ImageUrl.push(item.ImageUrl);
						// this.FileName.push(item.ImagePath);
					});
					this.InvClassCodeName = data.CusName;
					this.HPidName = data.ProviderName;
					this.HospHPidName = data.HPName;
					this.InvClassCode = data.CusCode;
					this.TXCusName = data.TXCusName;
					this.TXCusID = data.TXCusID;
					this.HPid = data.ProviderID;
					this.HospHPid = data.Hospital;
					loading.close();
					this.dialogVisiblesedit = true;
				}
				loading.close();
			},
			// 修改
			async cusRelationProviderEdit() {
				const loading = this.$loading({
					lock: true,
					text: "修改中...",
					spinner: "el-icon-loading",
					background: "rgba(255,255,255,0.3)"
				});
				let {
					code,
					message
				} = await CusRelationProviderEdit({
					ID: this.ID,
					CusCode: this.$refs.DsphFEditref[1].modelvalue == this.InvClassCodeName ?
						this.InvClassCode : this.$refs.DsphFEditref[1].modelvalue,
					InvClass: this.$refs.DsphFEditref[0].modelvalue,
					ProviderID: this.$refs.DsphFEditref[3].modelvalue == this.HPidName ?
						this.HPid : this.$refs.DsphFEditref[3].modelvalue,
					// ProviderType: this.$refs.DsphFEditref[2].modelvalue,
					TXCusID: this.$refs.DsphFEditref[2].modelvalue == this.TXCusName ?
						this.TXCusID : this.$refs.DsphFEditref[2].modelvalue,
					Hospital: this.$refs.DsphFEditref[4].modelvalue == this.HospHPidName ?
						this.HospHPid : this.$refs.DsphFEditref[4].modelvalue,
					VouchValiDate: this.$refs.DsphFEditref[5].modelvalue,
					Remark: this.$refs.DsphFEditref[6].modelvalue,
					HasHPInvoice: this.$refs.DsphFEditref[7].radios,
					imageNames: Array.from(this.SMSProviderUploadData, ({
						FileName
					}) => FileName)
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "修改成功"
					});
					this.rowboo = false;
					loading.close();
					this.dialogVisiblesedit = false;
					this.$parent.cusRelationProviderList();
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					});
				} else {
					this.$message({
						type: "error",
						message: message
					});
				}
				loading.close();
			},
			// 新增
			async cusRelationProviderAdd() {
				// console.log(this.$refs.DsphFAddref[7].radios,'this.$refs.DsphFAddref[7].radio');
				// return
				const loading = this.$loading({
					lock: true,
					text: "正在新增中...",
					spinner: "el-icon-loading",
					background: "rgba(255,255,255,0.3)"
				});

				let {
					code,
					message
				} = await CusRelationProviderAdd({
					CusCode: this.$refs.DsphFAddref[1].modelvalue == this.InvClassCodeName ?
						this.InvClassCode : this.$refs.DsphFAddref[1].modelvalue,
					InvClass: this.$refs.DsphFAddref[0].modelvalue,
					ProviderID: this.$refs.DsphFAddref[3].modelvalue == this.HPidName ?
						this.HPid : this.$refs.DsphFAddref[3].modelvalue,
					TXCusID: this.$refs.DsphFAddref[2].modelvalue == this.TXCusName ?
						this.TXCusID : this.$refs.DsphFAddref[2].modelvalue,
					Hospital: this.$refs.DsphFAddref[4].modelvalue == this.HospHPidName ?
						this.HospHPid : this.$refs.DsphFAddref[4].modelvalue,
					VouchValiDate: this.$refs.DsphFAddref[5].modelvalue,
					Remark: this.$refs.DsphFAddref[6].modelvalue,
					HasHPInvoice: this.$refs.DsphFAddref[7].radios,
					imageNames: Array.from(this.SMSProviderUploadData, ({
						FileName
					}) => FileName)
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "新增成功"
					});
					this.rowboo = false;
					this.handleList.length = 0;
					this.$parent.cusRelationProviderList();
					this.dialogVisibles = false;
					this.$refs.DsphFAddref.map((item, index) => {
						item.modelvalue = "";
					});
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					});
				} else {
					this.$message({
						type: "error",
						message: message
					});
				}
				loading.close();
			},
			// 编辑上传照片
			async cusRelationProviderUploadSalesInvListByEdit(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: "上传中...",
						spinner: "el-icon-loading",
						background: "rgba(255,255,255,0.3)"
					});
					let formData = new FormData();
					for (var i = 0; i < file.length; i++) {
						formData.append("files", file[i]);
					}
					let res = await CusRelationProviderUploadSalesInvListByEdit(formData);
					if (res.code == 0) {
						res.data.map((item, index) => {
							this.SMSProviderUploadData.push(item)

						});
						//console.log(this.ImageUrl);
						this.$message({
							type: "success",
							message: res.message
						});
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: "warning",
							message: res.message
						});
						loading.close();
					} else {
						this.$message({
							type: "error",
							message: res.message
						});
						loading.close();
					}
					loading.close();
				}
			},
			getFileDsphImg(file) {
				this.cusRelationProviderUploadSalesInvListByEdit(file);
			},
			//驳回
			async CusRelationProviderReject() {
				let arr = [];
				this.handleList.map((item, index) => {
					arr.push(item.ID);
				});
				let {
					code,
					data,
					message
				} = await CusRelationProviderReject({
					IDs: arr,
					RejectReason: this.RejectReason
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "驳回成功"
					});
					this.$parent.cusRelationProviderList();
					this.dialogVisiblesRejectReason = false;
					this.rowboo = false;
					this.handleList.length = 0;
					this.RejectReason = "";
					this.$refs.ProviderRef.$refs.fileTableSelect.clearSelection();
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					});
				} else if (code == 2) {
					this.dialogVisiblesdrjg = true;
					this.tableDatadrjg = data;
					this.title = "驳回结果";
				} else {
					this.$message({
						type: "error",
						message: message
					});
				}
			},
			// 删除
			async cusRelationProviderDelete() {
				let arr = [];
				this.handleList.map((item, index) => {
					arr.push(item.ID);
				});
				let {
					code,
					data,
					message
				} = await CusRelationProviderDelete({
					IDs: arr,
					RejectReason: this.RejectReason
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "删除成功"
					});
					this.$parent.cusRelationProviderList();
					this.dialogVisibledel = false;
					this.rowboo = false;
					this.handleList.length = 0;
					this.RejectReason = "";
					this.$refs.ProviderRef.$refs.fileTableSelect.clearSelection();
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					});
				} else if (code == 2) {
					this.dialogVisiblesdrjg = true;
					this.tableDatadrjg = data;
					this.title = "删除结果";
				} else {
					this.$message({
						type: "error",
						message: message
					});
				}
			},
			// 启用
			async cusRelationProviderActive() {
				let arr = [];
				this.handleList.map((item, index) => {
					arr.push(item.ID);
				});
				let {
					code,
					data,
					message
				} = await CusRelationProviderActive({
					IDs: arr
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "启用成功"
					});
					this.$parent.cusRelationProviderList();
					this.rowboo = false;
					this.handleList.length = 0;
					this.$refs.ProviderRef.$refs.fileTableSelect.clearSelection();
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					});
				} else if (code == 2) {
					this.dialogVisiblesdrjg = true;
					this.tableDatadrjg = data;
					this.title = "启用结果";
				} else {
					this.$message({
						type: "error",
						message: message
					});
				}
			},

			// 停用
			async cusRelationProviderDeActive() {
				let arr = [];
				this.handleList.map((item, index) => {
					arr.push(item.ID);
				});
				let {
					code,
					data,
					message
				} = await CusRelationProviderDeActive({
					IDs: arr
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "停用成功"
					});
					this.$parent.cusRelationProviderList();
					this.rowboo = false;
					this.handleList.length = 0;
					this.$refs.ProviderRef.$refs.fileTableSelect.clearSelection();
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					});
				} else if (code == 2) {
					this.dialogVisiblesdrjg = true;
					this.tableDatadrjg = data;
					this.title = "停用结果";
				} else {
					this.$message({
						type: "error",
						message: message
					});
				}
			},

			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({});
				if (code == 0) {
					this.fromdataadd[0].options = [];
					this.fromdataedit[0].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						};
						this.fromdataedit[0].options.push(obj);
						this.fromdataadd[0].options.push(obj);
					});
				}
			},
			// 导入
			async cusRelationProviderImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: "导入中...",
						spinner: "el-icon-loading",
						background: "rgba(255,255,255,0.3)"
					});
					let formData = new FormData();
					formData.append("file", file);
					let res = await CusRelationProviderImport(formData);
					if (res.code == 0) {
						this.$message({
							type: "success",
							message: res.message
						});

						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: "warning",
							message: res.message
						});
						loading.close();
					} else {
						this.dialogVisiblesdrjg = true;
						this.tableDatadrjg = res.data;
						this.title = "导入结果";
						this.$message({
							type: "error",
							message: res.message
						});
						loading.close();
					}
					this.$parent.cusRelationProviderList();
					loading.close();
				}
			},
			InvoiceImport(file) {
				this.cusRelationProviderImport(file);
			},
			async cusRelationProviderDownloadTemplet() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await CusRelationProviderDownloadTemplet({});
				if (code == 0) {
					window.location.href = data;
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					});
				} else {
					this.$message({
						type: "error",
						message: message
					});
				}
			},
			DsphfDowload() {
				this.cusRelationProviderDownloadTemplet();
			},
			async hospital(val) {
				let {
					code,
					data
				} = await HospitalList({
					HosType: "采购代理",
					HPName: val
				});
				if (code == 0) {
					this.HPid = data.data[0].HPID;
				}
			},
			async hospitalHP(val) {
				let {
					code,
					data
				} = await HospitalList({
					HosType: "医院",
					HPName: val
				});
				if (code == 0) {
					this.HospHPid = data.data[0].HPID;
				}
			},

			JXSUPChage(e) {
				this.HospitalInfoJSXUP(e.modelvalue);
				//console.log(e, 'e');
			},
			JXSChage(e) {
				this.HospitalInfoJSX(e.modelvalue);
				//console.log(e);
			},
			async HospitalInfoJSXUP(val) {
				let {
					code,
					data
				} = await HospitalInfo({
					hpid: val
				});
				if (code == 0) {
					this.$refs.DsphFEditref[2].modelvalue = data.HosType;
				}
			},
			async HospitalInfoJSX(val) {
				let {
					code,
					data
				} = await HospitalInfo({
					hpid: val
				});
				if (code == 0) {
					this.$refs.DsphFAddref[2].modelvalue = data.HosType;
				}
			},
			async remoteHosType(query) {
				this.loading = true;
				let {
					code,
					data
				} = await HospitalList({
					//HosType: "经销商",
					IsTXCus: 1,
					HPName: query
				});
				if (code == 0) {
					this.fromdataadd[2].options = [];
					this.fromdataedit[2].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						};
						this.fromdataadd[2].options.push(obj);
						this.fromdataedit[2].options.push(obj);
					});
					this.loading = false;
				}
			},
			async remoteMethodtowHB(query) {
				this.loading = true;
				let {
					code,
					data
				} = await HospitalList({
					HosType: "采购代理",
					//IsTXCus: 1,
					HPName: query
				});
				if (code == 0) {
					this.fromdataadd[3].options = [];
					this.fromdataedit[3].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						};
						this.fromdataadd[3].options.push(obj);
						this.fromdataedit[3].options.push(obj);
					});
					this.loading = false;
				}
			},
			// 医院下拉
			async remoteMethodtows(query) {
				this.loading = true;
				let {
					code,
					data
				} = await HospitalList({
					HosType: "医院",
					HPName: query
				});
				if (code == 0) {
					this.fromdataadd[4].options = [];
					this.fromdataedit[4].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						};
						this.fromdataadd[4].options.push(obj);
						this.fromdataedit[4].options.push(obj);
					});
					this.loading = false;
				}
			},
			CRExport() {
				this.$emit("CRExport");
			},
			// 上传照片(多选)
			async UploadPhotos(file) {
				if (this.rowboo == true) {
					const loading = this.$loading({
						lock: true,
						text: "正在上传...",
						spinner: "el-icon-loading",
						background: "rgba(255,255,255,0.3)"
					});
					let formdata = new FormData();
					for (var i = 0; i < file.length; i++) {
						formdata.append("files", file[i]);
					}
					let {
						data,
						code,
						message
					} = await CusRelationProviderUploadSalesInvListPic(formdata, this.ID);
					if (code == 0) {
						this.$message({
							type: "success",
							message: message
						});
						loading.close();
						// this.rowboo = false
						this.$parent.cusRelationProviderList();
						return;
					} else if (code == 101) {
						this.$message({
							type: "warning",
							message: message
						});
						loading.close();
						return;
					} else {
						this.dialogVisiblesdrjg = true;
						this.tableDatadrjg = data;
						this.title = "上传结果";
						this.$message({
							type: "error",
							message: message
						});
						loading.close();
					}
				}

				this.$message({
					type: "error",
					message: "请选择要操作的数据！"
				});
			},
			onRowClick(val) {
				this.ID = val.ID;
				this.rowboo = true;
				//console.log('val', val)
			},
			adduser() {
				this.dialogVisibles = true;
				this.hospitalGetHospitalType();
				this.inventoryClassList();
			},
			cancel() {
				this.dialogVisibles = false;
			},
			dialogOK() {
				this.cusRelationProviderAdd();
			},
			update() {
				if (this.handleList.length === 1) {
					this.ID = this.handleList[0].ID;
					this.rowboo = true;
					this.cusRelationProviderInfo();
					this.hospitalGetHospitalType();
					this.inventoryClassList();
					return;
				}
				this.$message({
					type: "error",
					message: "请选择要复制的数据！"
				});
			},
			canceledit() {
				this.dialogVisiblesedit = false;
			},
			dialogOKedit() {
				this.cusRelationProviderEdit();
			},
			cancelRejectReason() {
				this.dialogVisiblesRejectReason = false;
			},
			dialogOKRejectReason() {
				this.CusRelationProviderReject();
			},

			Rejectapproval() {
				if (this.handleList.length >= 1) {
					// if (this.handleList.some(item => item.NeedReasonWhenDelete == 1)) {
					//   this.dialogVisiblesRejectReason = true;
					//   return;
					// } else {
					//   this.dialogVisibledel = true;
					//   return;
					// }
					this.dialogVisiblesRejectReason = true;
					// this.handleList.forEach((item, index) => {
					//   if (item.NeedReasonWhenDelete == 1) {
					//     this.dialogVisiblesRejectReason = true
					//     return
					//   } else {
					//     this.dialogVisibledel = true
					//     return
					//   }
					// })
					return;
				}
				this.$message({
					type: "warning",
					message: "请选择要驳回的数据(多选)！"
				});
			},
			canceldel() {
				this.dialogVisibledel = false;
			},
			dialogOKdel() {
				this.cusRelationProviderDelete();
			},
			del() {
				if (this.handleList.length >= 1) {
					this.dialogVisibledel = true;
					return;
				}
				this.$message({
					type: "warning",
					message: "请选择要删除的数据(多选)！"
				});
			},
			Active() {
				if (this.handleList.length >= 1) {
					this.dialogVisibledeactivate = true;
					return;
				}
				this.$message({
					type: "error",
					message: "请选择要启用的数据(多选)！"
				});
			},
			canceldeactivate() {
				this.dialogVisibledeactivate = false;
			},
			dialogOKdeactivate() {
				this.cusRelationProviderActive();
				this.dialogVisibledeactivate = false;
			},

			downs(index) {
				// //console.log("index", index)
				if (index == 0) {
					this.dialogVisiblesU8 = true;
				}
				if (index == 1) {
					this.dialogVisiblesU8d = true;
				}
			},
			DeActive() {
				if (this.handleList.length >= 1) {
					this.dialogVisibledeactivateDe = true;
					return;
				}
				this.$message({
					type: "error",
					message: "请选择要停用的数据(多选)！"
				});
			},
			canceldeactivateDe() {
				this.dialogVisibledeactivateDe = false;
			},
			dialogOKdeactivateDe() {
				this.cusRelationProviderDeActive();
				this.dialogVisibledeactivateDe = false;
			},
			handleCurrentChange(pageindex) {
				this.$emit("handleCurrentChange", pageindex);
			},
			handleSizeChange(paegSzie) {
				this.$emit("handleSizeChange", paegSzie);
			},
			handleSelectionChange(val) {
				this.handleList = val;
				if (val.length === 1) {
					this.ID = val[0].ID;
					this.rowboo = true;
					return;
				}
				this.rowboo = false;
				if (val.length === 0) {
					this.ID = "";
				}
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false;
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false;
			}
		},
		watch: {
			dialogVisibles: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						//console.log(newVal);
						this.SMSProviderUploadData = []
						this.ImageUrl = [];
						this.FileName = [];
						this.TXCusName = "";
						this.TXCusID = "";
					}
				}
			},
			dialogVisiblesedit: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						this.SMSProviderUploadData = []
						this.ImageUrl = [];
						this.FileName = [];
						this.TXCusName = "";
						this.TXCusID = "";
					}
				}
			},
			dialogVisiblesRejectReason: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						this.RejectReason = "";
					}
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.SMSProviderFlex {
		width: 100%;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		// outline: 1px solid red;
	}

	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}

	.imgBJ {
		width: 120px;
		height: 120px;
		position: relative;
		// top: 38px;
		margin-left: 20px;
		border: 1px solid #c1c5ca;
	}

	.uploadImg {
		// width: 800px;
		padding-left: 25px;
		// border: 1px solid red;
	}

	.DelOrSee {
		width: 120px;
		height: 120px;
		display: inline-block;
		background-color: #000;
		opacity: 0.2;
		position: relative;
		margin-left: -120px;
	}

	.del_icon {
		position: relative;
		left: 80px;
		top: -50px;
		z-index: 99;
		cursor: pointer;
	}

	.See_icon {
		position: relative;
		left: 110px;
		top: -50px;
		z-index: 99;
		cursor: pointer;
	}
</style>
